var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('details-row',{attrs:{"icon":"information-o","padding":"gl-p-4","data-testid":"conan-recipe"}},[_c('gl-sprintf',{attrs:{"message":_vm.$options.i18n.recipeText},scopedSlots:_vm._u([{key:"recipe",fn:function(){return [_vm._v(_vm._s(_vm.packageMetadata.recipe))]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }